export default __webpack_public_path__ + "static/B0234-a08a98ffbeee20c17d49591d1f7757e0.png";